import React, { useState } from "react";
import Select from "react-select";
import "./Demo_Modal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Form, Modal } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import Common_Btn from "../common-btn/Common_Btn";
import Success_Lottie from "../lottie/success-lottie/Success_Lottie";

const Demo_Modal = ({ show, handleClose }) => {
  const [showModal, setShowModal] = useState(false);
  const productOptions = [
    { value: "Mobile Applications", label: "Mobile Applications" },
    { value: "Web Platform", label: "Web Platform" },
    { value: "Admin Panel", label: "Admin Panel" },
    { value: "All-in-One Solution", label: "All-in-One Solution" },
  ];
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        contentClassName="custom_modal_content"
      >
        <div className="modal_header_div">
          <p className="modal_title">Tell us your Needs</p>
          <p className="modal_subtitle">We'll Handle the Rest</p>
        </div>

        <div className="close_btn_holder" onClick={handleClose}>
          <FontAwesomeIcon icon={faXmark} className="close_btn" />
        </div>

        <Modal.Body className="custom_modal_body">
          <Form className="lead_form">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <Form.Group className="mb-4">
                  <Form.Label>
                    Full Name <span>*</span>
                  </Form.Label>
                  <Form.Control type="text" placeholder="Enter your name" />
                </Form.Group>
              </div>

              <div className="col-lg-6 col-md-6">
                <Form.Group className="mb-4">
                  <Form.Label>Company / Organization Name</Form.Label>
                  <Form.Control type="text" placeholder="Enter company name" />
                </Form.Group>
              </div>

              <div className="col-lg-6 col-md-6">
                <Form.Group className="mb-4">
                  <Form.Label>
                    Email Address <span>*</span>
                  </Form.Label>
                  <Form.Control type="email" placeholder="Enter your Email" />
                </Form.Group>
              </div>

              <div className="col-lg-6 col-md-6">
                <Form.Group className="mb-4">
                  <Form.Label>
                    Mobile Number <span>*</span>
                  </Form.Label>

                  <PhoneInput
                    country="in"
                    enableSearch
                    specialLabel=""
                    inputClass="phone_input"
                    containerClass="phone_container"
                    buttonClass="phone_flag_btn"
                  />
                </Form.Group>
              </div>

              <div className="col-lg-6 col-md-6">
                <Form.Group className="mb-4">
                  <Form.Label>
                    Select Product Interest <span>*</span>
                  </Form.Label>
                  <Select
                    options={productOptions}
                    placeholder="---Select---"
                    classNamePrefix="react-select"
                  />
                </Form.Group>
              </div>

              <div className="col-lg-6 col-md-6">
                <Form.Group className="mb-4">
                  <Form.Label>Industry Type</Form.Label>
                  <Select
                    options={productOptions}
                    placeholder="---Select---"
                    classNamePrefix="react-select"
                  />
                </Form.Group>
              </div>

              <div className="col-lg-12 col-md-12">
                <Form.Group className="mb-4">
                  <Form.Label>Message / Custom Requirements</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Tell us what you're looking for..."
                  />
                </Form.Group>
              </div>
            </div>
          </Form>

          <div className="submit_btn_holder">
            <Common_Btn text="Submit Now" onClick={() => setShowModal(true)} />
          </div>
        </Modal.Body>
      </Modal>

      <Success_Lottie isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default Demo_Modal;
